import { SelectChangeEvent } from "@mui/material";
import { redirect, useLoaderData, useNavigate } from "react-router-dom";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { SET_CURRENT_BUTTON } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { doFetch } from "../../utils/doFetch";
import { ButtonType, Buttons } from "./Buttons";
import { ButtonItem, IButtonData } from "./ButtonsData";

export const ButtonsRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  if (params.type) {
    // handles type change
    return doFetch(`buttons/${params.type}`, { signal: request.signal }, true, false);
  } else {
    // handles default board
    return redirect("union");
  }
};

export const ButtonsRoute = () => {
  const data = useLoaderData() as IButtonData;
  const navigate = useNavigate();
  const { dispatch } = useGlobal();

  const handleChangeButtonType = (event: SelectChangeEvent<ButtonType>) => {
    const newButtonType = Object.keys(ButtonType).find(key =>
      ButtonType[key as keyof typeof ButtonType] === event.target.value);
    navigate(`/buttons/${newButtonType}`);
  };

  const handleButtonClick = (button: ButtonItem, buttonSubUrl: string) => {
    dispatch({ type: SET_CURRENT_BUTTON, payload: button });
    if (!!buttonSubUrl && button) {
      navigate(`/${buttonSubUrl}/${button.boardCode.toLocaleLowerCase()}`);
    }
  }

  return (
    <Buttons data={data}
      handleButtonClick={handleButtonClick}
      handleChangeButtonType={handleChangeButtonType}
    />
  )
};